<template>
  <div class="form tab-content">
    <input-field
      value=""
      :label="$t('ExistingMaterial')"
      size="large"
      inputType="group"
    />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_clamps')"
      @input="updateValue('tp_pe_clamps', $event)"
      :label="$t('Clamps')"
      size="small"
      inputType="select"
      selectOptions="list_pole_clamp"
      :fieldDisabled="readOnly"
    />

    <input-field
      :value="
        getValueInObject('tp_pe_existing_aerial_subterranean_transitions')
      "
      @input="
        updateValue('tp_pe_existing_aerial_subterranean_transitions', $event)
      "
      :label="$t('AerialSubterraneanTransitions')"
      size="small"
      inputType="number"
      :step="1"
      :min="0"
      :max="4"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_ground_cables')"
      @input="updateValue('tp_pe_existing_ground_cables', $event)"
      :label="$t('GroundCables')"
      size="small"
      inputType="number"
      :step="1"
      :max="2"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_closures')"
      @input="updateValue('tp_pe_existing_closures', $event)"
      :label="$tc('Closure', 2)"
      size="small"
      inputType="number"
      :step="1"
      :max="3"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_riser_pipes')"
      @input="updateValue('tp_pe_existing_riser_pipes', $event)"
      :label="$t('RiserPipes')"
      size="small"
      inputType="number"
      :step="1"
      :max="2"
      :fieldDisabled="readOnly"
    />

    <div style="width: 100%" />

    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_existing_bt_hanging_support')"
      @input="updateValue('tp_pe_existing_bt_hanging_support', $event)"
      :label="$t('BTHangingSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_existing_bt_anchor_support')"
      @input="updateValue('tp_pe_existing_bt_anchor_support', $event)"
      :label="$t('BTAnchorSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      v-if="isElectrical"
      :value="getValueInObject('tp_pe_existing_bt_double_anchor_support')"
      @input="updateValue('tp_pe_existing_bt_double_anchor_support', $event)"
      :label="$t('BTDoubleAnchorSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_ft_hanging_support')"
      @input="updateValue('tp_pe_existing_ft_hanging_support', $event)"
      :label="$t('FTHangingSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_ft_anchor_support')"
      @input="updateValue('tp_pe_existing_ft_anchor_support', $event)"
      :label="$t('FTAnchorSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_ft_double_anchor_support')"
      @input="updateValue('tp_pe_existing_ft_double_anchor_support', $event)"
      :label="$t('FTDoubleAnchorSupport')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_existing_ft_standoff')"
      @input="updateValue('tp_pe_existing_ft_standoff', $event)"
      :label="$t('FTStandoff')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />

    <input-field
      value=""
      :label="$t('MaterialToInstall')"
      size="large"
      inputType="group"
    />

    <input-field
      :value="getValueInObject('tp_pe_install_closures')"
      @input="updateValue('tp_pe_install_closures', $event)"
      :label="$tc('Closure', 2)"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_install_fo_standoff')"
      @input="updateValue('tp_pe_install_fo_standoff', $event)"
      :label="$t('FOStandoff')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_install_ras_fo')"
      @input="updateValue('tp_pe_install_ras_fo', $event)"
      label="RAS FO"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_install_extensions')"
      @input="updateValue('tp_pe_install_extensions', $event)"
      :label="$t('Extensions')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
    <input-field
      :value="getValueInObject('tp_pe_install_slack')"
      @input="updateValue('tp_pe_install_slack', $event)"
      :label="$t('Slack')"
      size="small"
      inputType="number"
      :step="1"
      :fieldDisabled="readOnly"
    />
  </div>
</template>

<script>
import { poleEffortModuleTabsMixin } from "@/mixins/forms/poleEffortTabsMixin";
import InputField from "../../_Molecules/InputField";

export default {
  name: "PoleMaterialTab",
  components: { InputField },
  mixins: [poleEffortModuleTabsMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/PoleEffortModule/MaterialTab.vue